<ng-container *ngIf="cardToken$ | async as cardToken; else addCard">
  <div
    class="add-card-button d-flex align-items-center justify-content-between w-100 py-2 payment-detail"
    [ngClass]="{
      'bg-frozen': cardToken.Frozen,
    }"
  >
    <div class="d-flex flex-row gap-2 align-items-center text-white">
      <ng-container [ngSwitch]="cardToken!.CardType">
        <img class="mastercard-logo" *ngSwitchCase="1" src="assets/images/payment-icons/_Mastercard.svg" />
        <img class="mastercard-logo" *ngSwitchCase="2" src="assets/images/payment-icons/_AMEX.svg" />
        <img class="mastercard-logo" *ngSwitchCase="3" src="assets/images/payment-icons/visa-logo.png" />
        <img class="mastercard-logo" *ngSwitchCase="4" src="assets/images/payment-icons/_Discover.svg" />
        <img class="mastercard-logo" *ngSwitchCase="5" src="assets/images/payment-icons/_JCB.svg" />
        <img class="mastercard-logo" *ngSwitchCase="7" src="assets/images/payment-icons/_DinnersClub.svg" />
        <img class="mastercard-logo" *ngSwitchCase="8" src="assets/images/payment-icons/_UnionPay.svg" />
        <div class="mastercard-logo" *ngSwitchDefault></div>
      </ng-container>

      <span class="card-num font-size-14 me-1">({{ (cardToken?.CardNumber | creditCardNumber | slice : -5).trim() }})</span>
    </div>

    <a class="text-white mt-1" [routerLink]="'/ecash'" (click)="goToJetsCash()">
      <span class="material-icons">chevron_right</span>
    </a>
  </div>
</ng-container>
<ng-template #addCard>
  <a [routerLink]="'/ecash'">
    <button class="btn d-flex align-items-center text-white fw-bold justify-content-center gap-2 w-100">
      <span class="material-icons font-size-20"> add_card </span>
      <span class="font-size-14 fw-bold"> {{ 'barcode.add.card' | translate }}</span>
    </button>
  </a>
</ng-template>
